import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getDocumentsPrice, selectPrice, selectPricesIsLoading } from '../feature';

export const useGetDocumentsPrice = () => {
  const price = useAppState(selectPrice);
  const isLoading = useAppState(selectPricesIsLoading);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getDocumentsPrice());
  }, []);

  return useMemo(() => ({ price, isLoading }), [price, isLoading]);
};
